module.exports = __webpack_public_path__ + "static/img/agenda-2026.97aa1c6f.jpg";